
import Agora from "@/assets/common/Agora";
import store from "@/store";
import { computed, defineComponent } from "vue";
import Icon from "../icon.vue";

export default defineComponent({
  name: "room-controls",
  components: {
    Icon
  },
  setup() {
    const agora: Agora | null = window.agora;
    const micEnabled = computed(() => store.state.micEnabled);
    const cameraEnabled = computed(() => store.state.cameraEnabled);

    // 初始化控制器状态
    async function initStatus() {
      if (!agora) return;

      const micTrack = agora.micTrack;
      const micTrackReady = agora.micTrackReady;
      if (micTrackReady) {
        await micTrackReady;
        store.commit("setMicEnabled", (micTrack as any)._enabled);
      }

      const cameraTrack = agora.cameraTrack;
      const cameraTrackReady = agora.cameraTrackReady;
      if (cameraTrackReady) {
        store.commit("setCameraEnabled", (cameraTrack as any)._enabled);
      }
    }

    // 切换麦克风状态
    async function toogleMic() {
      if (micEnabled.value) {
        agora?.closeMicTrack();
      } else {
        agora?.createMicTrack();
      }

      store.commit("setMicEnabled", !micEnabled.value);
    }

    // 切换摄像头状态
    async function toogleCamera() {
      if (cameraEnabled.value) {
        agora?.closeCameraTrack();
      } else {
        const local = document.getElementById("local");
        local && agora?.createCameraTrack(local);
      }

      store.commit("setCameraEnabled", !cameraEnabled.value);
    }

    initStatus();

    return {
      micEnabled,
      cameraEnabled,
      toogleMic,
      toogleCamera
    };
  }
});
